// src/stage2/Life Meters/SocialDots.jsx
import React from "react";
import "./lifeMeter.css";

export default function SocialDots({ filled = 1, total = 4 }) {
  return (
    <div className="social-dots"> (Social Credit)
      {Array.from({ length: total }).map((_, i) => (
        <span
          key={i}
          className={`social-dot ${i < filled ? "filled" : ""}`}
        />
      ))}
    </div>
  );
}
